import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { HitAnmeldungComponent } from '../../../../hit/hit-anmeldung/hit-anmeldung.component';
import { HitLoginResponse } from '../../../../hit/hit-registrierung/classes/hit-login-response';

@Component({
    selector: 'kiene-vvvo-hinzufuegen-hit-dialog',
    templateUrl: './vvvo-hinzufuegen-hit-dialog.component.html',
    styleUrls: ['./vvvo-hinzufuegen-hit-dialog.component.scss'],
})
export class VvvoHinzufuegenHitDialogComponent implements OnInit {
    @ViewChild('hitAnmeldungComp') hitAnmeldungComp?: HitAnmeldungComponent;

    constructor(public dialogRef: MatDialogRef<VvvoHinzufuegenHitDialogComponent>) {}

    ngOnInit(): void {}

    hitLoginSucceeded(value: HitLoginResponse) {
        this.dialogRef.close(value);
    }

    anmelden(): void {
        this.hitAnmeldungComp?.anmelden();
    }
}
